// extracted by mini-css-extract-plugin
export var dropdownButton = "_38-0";
export var fullWidthDropdownButton = "_38-1";
export var icon = "_38-3";
export var iconPlaceholder = "_38-2";
export var menuItemRow = "_38-5";
export var shortcutContainer = "_38-4";